import { Theme } from '@mui/material';
export const descriptionWrapperStyles = (theme: Theme) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '1.25rem 0',
  gap: {
    xs: '1.25rem',
    md: '1.75rem'
  },
  borderBottom: '0.063rem solid',
  borderColor: theme.palette.neutrals?.primary
});
export const buttonBoxStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  columnGap: {
    xs: '.5rem',
    md: '.75rem'
  },
  rowGap: {
    xs: '.75rem',
    md: '1rem'
  },
  flexDirection: {
    xs: 'column',
    md: 'row'
  },
  flexWrap: 'wrap'
};